module.exports = __webpack_public_path__ + "img/A903.7ad58666.jpg";